import { createFileRoute } from "@tanstack/react-router";
import { ReferralLinkApproval } from "@/pages/referral-link-approval/ReferralLinkApproval";

export const Route = createFileRoute("/partner/referral-link-approval")({
	head: () => ({
		meta: [{ title: "Approve Referral Link" }],
	}),
	component: ReferralLinkApproval,
});
